import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import type { StoreLocator as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import leadInStyles from "../../styles/composable/lead-in.module.scss";
import panelStyles from "../../styles/composable/panel.module.scss";
import valuePropsStyles from "../../styles/composable/value-props.module.scss";
import styles from "./index.module.scss";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/store_locator/store_locator.html`` (#33285). The block is a
 * value-less StaticBlock: the serialized value is an empty object (or null on
 * the standalone template path) and is ignored.
 */
export const StoreLocator = (_props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <section
            className={concatClassNames([
                panelStyles.panel,
                panelStyles.panelCenter,
                styles.featuredRetailer,
            ])}
            style={{
                backgroundImage: `url('${staticURL}img/store-locator/panel-bg-featured-locations.jpg')`,
            }}
        >
            <div className={panelStyles.panelContent}>
                <div className={leadInStyles.leadIn}>
                    <h2>Feel the Sealy difference for yourself</h2>
                    <a
                        className="button"
                        href="/find-a-retailer"
                        title="Find a Retailer"
                    >
                        Visit a retailer near you
                    </a>
                </div>
                <div
                    className={concatClassNames([
                        valuePropsStyles.valueProps,
                        valuePropsStyles.inPanel,
                    ])}
                >
                    <div className={valuePropsStyles.valuePropsItem}>
                        <figure className={valuePropsStyles.valuePropsIcon}>
                            <img
                                className="img-responsive"
                                src={`${staticURL}img/store-locator/icon-shopping-tips.png`}
                                alt="Shopping Tips"
                                loading="lazy"
                                decoding="async"
                            />
                        </figure>
                        <a
                            className={concatClassNames([
                                valuePropsStyles.valuePropsCopy,
                                styles.featuredRetailerCopy,
                            ])}
                            href="/shopping-tips"
                            title="Shopping Tips"
                        >
                            <h4
                                className={concatClassNames([
                                    valuePropsStyles.valuePropsHeadline,
                                    styles.featuredRetailerHeadline,
                                ])}
                            >
                                Mattress Shopping Tips
                            </h4>
                            <p
                                className={concatClassNames([
                                    valuePropsStyles.valuePropsSubtext,
                                    styles.featuredRetailerSubtext,
                                ])}
                            >
                                Tips for your in-store experience
                            </p>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
